import React from 'react';

import {StubProps} from './interface';

const Stub = (props: StubProps) => {
	if (Array.isArray(props.children)) {
		return <>{props.children}</>;
	}

	// We don't have anything here to use it as a key!
	return Object.values(props)
		.filter((value) => React.isValidElement(value))
		.map((value, index) => (
			<React.Fragment key={value.key || new Date().toString() + index}>{value}</React.Fragment>
		));
};

export default Stub;
